import { Box, IconButton, Tooltip, Typography } from '@mui/material'
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import { esES } from '@mui/x-data-grid/locales'
import { useStyles } from './styles'
import { useBody } from './body'
import { FiltersDrawer } from '../../../../components/filtersDrawer'
import { DinamicForm } from '../../../../components/dinamicForm'
import { useTranslation } from 'react-i18next'
import { icons } from '../../../../utils/icons'
import { GoBack } from '../../../../components/goBack'
import { esESGrid } from './utils/esEs'
import { BreadCrumb } from '../../../../components'

const ReportPropgramationData = () => {
  const { t } = useTranslation()
  const {
    loading,
    columns,
    row,
    input,
    errors,
    counter,
    filterData,
    queryParams,
    refreshTable,
    onChange,
    cleanFIlters,
  } = useBody()
  const styles = useStyles()

  return (
    <Box sx={styles.container}>
      {/* FLOATS */}
      <BreadCrumb
        removeBreadcrumb={['reports']}
        replaceLabels={{ programation: 'programationByAreaAndDepartment' }}
      />
      <FiltersDrawer
        cleanFilter={cleanFIlters}
        count={counter}
        right={0}
        top={50}
      >
        <Box sx={styles.section}>
          <DinamicForm
            errors={errors}
            input={Object.values({
              ...input,
              from: {
                ...input?.from,
                rest: {
                  ...filterData?.intervale?.value === '1w' ? {
                    shouldDisableDate: (date: Date) => {
                      return new Date(date.valueOf())?.getDay?.() !== 1 || (filterData?.to && new Date(date.valueOf()) > filterData?.to)
                    },
                    textField: {
                      disabled: true
                    }
                  } : {
                    shouldDisableDate: (date: Date) => {
                      if(!filterData?.to) return false
                      return new Date(date.valueOf()) > filterData?.to
                    },

                  }
                }
              }
            })}
            values={filterData}
            onChange={onChange}
          />
        </Box>
      </FiltersDrawer>

      {
        !!queryParams.size && (
          <GoBack path='/dashboard' />
        )
      }

      <Box sx={styles.header}>
        <Typography variant='title_grey_big'>
          {t('dashboard.dataSettings.title2')}
        </Typography>

        <Box>
          <Tooltip title={t('ToolTips.refresh')}>
            <IconButton
              onClick={() => {
                refreshTable()
              }}
            >
              {icons('refresh')}
            </IconButton>
          </Tooltip>

          {(counter || 0) > 0 && (
            <Tooltip title={t('ToolTips.clearFilters')}>
              <IconButton
                sx={(styles.clean, (counter || 0) > 0 ? null : styles.hide)}
                onClick={() => {
                  cleanFIlters()
                }}
              >
                {icons('clean')}
              </IconButton>
            </Tooltip>
          )}
        </Box>
      </Box>

      <DataGrid
        columns={columns}
        rows={row ?? []}
        getRowId={(row) => row.id}
        autoHeight
        disableVirtualization
        loading={loading}
        slots={{ toolbar: GridToolbar }}
        localeText={esESGrid}
        disableDensitySelector
        disableColumnMenu
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            csvOptions: { fileName: t('dashboard.dataSettings.title') },
          },
          filterPanel: {
            logicOperators: [],
            filterFormProps: {
              operatorInputProps: {
                disabled: true,
                sx: { display: 'none' },
              },
            },
          },
          pagination: {
            labelRowsPerPage: '',
          },
        }}
      />
    </Box>
  )
}

export { ReportPropgramationData }
